import { TextStyle } from 'react-native';
import theme from 'shared/styles/theme';

const toCamelCase = (str: string) => {
  return str
    .toLowerCase()
    .replace(/_([a-z])/g, (_, char: string) => char?.toUpperCase());
};

const abbreviations: { [key: string]: string } = {
  SMALL: 'sm',
  XSMALL: 'xs',
  MEDIUM: 'md',
  LARGE: 'lg',
  S: 'sm',
  L: 'lg',
  M: 'md',
};

const abbreviateStyle = (style: string) => {
  const parts = style.split('_');
  if (parts.length < 2) {
    return '';
  }

  const styleName = parts[1];
  if (abbreviations[styleName]) {
    parts[1] = abbreviations[styleName];
  }

  return parts.join('_');
};

const getVXLFont = (style: string): TextStyle | undefined => {
  const abbreviatedStyle = abbreviateStyle(style);

  const parts = abbreviatedStyle.split('_');
  if (parts.length < 2) {
    return undefined;
  }

  const styleName = toCamelCase(parts.slice(1).join('_'));

  let folderName = toCamelCase(parts[0]);

  if (folderName === 'hand') {
    folderName = 'varoHand';
  }

  const styleGroup = theme.typography[folderName] as
    | { [key: string]: TextStyle }
    | undefined;
  if (!styleGroup) {
    return theme.typography.body.baseBold;
  }

  const updatedStyle = styleGroup[styleName];

  if (!updatedStyle) {
    return theme.typography.body.baseBold;
  }

  return updatedStyle;
};

export { getVXLFont };
